import { useEffect, useState } from "react";
import { all_routes } from "../../router/all_routes";
import { Link } from "react-router-dom";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import api from "../../../services/api";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import Loader from "../../../core/common/loader";
import DeleteModal from "../../../core/modals/deleteModal";
import EditEmployee from "./edit_empolyee_modal";
import { showBasicAlert } from "../../../core/common/useAlert";
import PredefinedDateRanges from "../../../core/common/datePicker";
import CommonSelect from "../../../core/common/commonSelect";
import moment from "moment";

const EmployeesGrid = () => {
  const signature = localStorage.getItem("signature");
  const [isLoading, setIsLoading] = useState(false); // state to track loading
  const [data, setData] = useState<any[]>([]);
  const [filteredData, setFilteredData] = useState(data);
  const [getEmployeesListData, setgetEmployeesListData] = useState<
    any | undefined
  >(undefined);

  const [getDesignation, setgetDesignation] = useState<any[]>([]);
  const [getAllCompanyList, setgetAllCompanyList] = useState<any[]>([]);
  const [CountryCode, setCountryCode] = useState<any[]>([]);
  const [companyName, setCompanyName] = useState<any | null>(null);

  const [modalData, setModalData] = useState(null);
  const handleEditOpenModal = async (record: any) => {
    var companyId = record.CompanyId;
    var companyType = record.CompanyType;
    const [getReportingOfficer] = await Promise.all([
      api.post("userService/getReportingOfficer", {
        signature,
        companyId,
        companyType,
      }),
    ]);

    record.CountryCode = CountryCode;
    record.signature = signature;
    record.getAllCompanyList = getAllCompanyList;
    record.getDesignation = getDesignation;
    record.getReportingOfficer = getReportingOfficer.data.data.data;
    setModalData(record);
  };

  useEffect(() => {
    // This will run when the component mounts
    const fetchDashboardData = async () => {
      try {
        await updateUI();
      } catch (err: any) {
        showBasicAlert(err.data.message[0].msg);
        console.error("Error fetching dashboard data:", err);
      }
    };

    fetchDashboardData();
  }, []);

  const updateUI = async () => {
    // Making all requests in parallel
    setIsLoading(true);
    const [
      getDesignation,
      countryResponse,
      getAllCompanyList,
      getEmployeesListData,
    ] = await Promise.all([
      api.post("userService/getDesignation", { signature }),
      api.post("userService/getCountry", { signature }),
      api.post("userService/getAllCompanyList", { signature }),
      api.post("userService/getEmployeesListData", { signature }),
    ]);
    // Setting the states after all data is fetched
    setgetDesignation(getDesignation.data.data.data);
    setCountryCode(countryResponse.data.data);

    setgetAllCompanyList(getAllCompanyList.data.data.data);
    setgetEmployeesListData(getEmployeesListData.data.data.data);

    setData(getEmployeesListData.data.data.data.allUsers);
    setFilteredData(getEmployeesListData.data.data.data.allUsers);

    setMasterCompanyData(getEmployeesListData.data.data.data.masterCompanies);
    setPatnerCompanyData(getEmployeesListData.data.data.data.partnerCompanies);

    if (statusFilter == null) {
      setStatusFilter("Active");
    }
    if (companyName == null) {
      setCompanyName({
        id: getAllCompanyList.data.data.data[0].id,
        name: getAllCompanyList.data.data.data[0].name,
      });
    }

    setIsLoading(false);
    return;
  };

  const fetchUpdatedRecords = async () => {
    // Making all requests in parallel
    setIsLoading(true);
    const [getEmployeesListData] = await Promise.all([
      api.post("userService/getEmployeesListData", { signature }),
    ]);
    // Setting the states after all data is fetched
    setgetEmployeesListData(getEmployeesListData.data.data.data);

    setData(getEmployeesListData.data.data.data.allUsers);
    setFilteredData(getEmployeesListData.data.data.data.allUsers);

    setIsLoading(false);
    return;
  };

  const [deleteRecord, setDeleteRecord] = useState<{
    key: number;
    name: string;
  } | null>(null);
  //Delete Company Start

  const handleDelete = async () => {
    if (deleteRecord) {
      try {
        var id = deleteRecord.key;
        setIsLoading(true);
        const response = await api.post("userService/deleteEmployee", {
          signature,
          id,
        });
        await updateUI();
        setIsLoading(false); // hide loader after response
        showBasicAlert(response.data.message[0].msg);
      } catch (error: any) {
        setIsLoading(false); // hide loader after response
        showBasicAlert(error.data.message[0].msg);
        console.error("Error submitting data", error);
      }
      setDeleteRecord(null);
    }
  };

  const [selectedCompany, setSelectedCompany] = useState<string>("");
  const [masterCompanyData, setMasterCompanyData] = useState<any[]>([]);
  const [patnerCompanyData, setPatnerCompanyData] = useState<any[]>([]);

  const allCompanies = [...masterCompanyData, ...patnerCompanyData];

  const [statusFilter, setStatusFilter] = useState<string | null>(null);
  const [sortBy, setSortBy] = useState<string>("Last 7 Days");

  const [selectedStartDate, setSelectedStartDate] =
    useState<moment.Moment | null>(null);
  const [selectedEndDate, setSelectedEndDate] = useState<moment.Moment | null>(
    null
  );

  const handleReset = () => {
    setFilteredData(data);
    setSelectedEndDate(null);
    setSelectedStartDate(null);
    setStatusFilter("Active");
    setCompanyName({
      id: getAllCompanyList[0].id,
      name: getAllCompanyList[0].name,
    });
    setSortBy("Last 7 Days");
  };

  useEffect(() => {
    if (filteredData) {
      var newFilteredData = data
        .filter((item: any) => {
          if (statusFilter && item.Status !== statusFilter) {
            return false;
          }
          if (companyName != "" && item.CompanyName !== companyName?.name) {
            return false;
          }

          if (selectedStartDate && selectedEndDate) {
            const createdDate = new Date(item.CreatedDate);

            const startDate =
              selectedStartDate instanceof Date
                ? selectedStartDate
                : selectedStartDate.toDate();
            const endDate =
              selectedEndDate instanceof Date
                ? selectedEndDate
                : selectedEndDate.toDate();

            if (createdDate < startDate || createdDate > endDate) {
              return false;
            }
          }
          return true;
        })
        .sort((a: any, b: any) => {
          switch (sortBy) {
            case "Recently Added":
              return (
                new Date(b.JoiningDate).getTime() -
                new Date(a.JoiningDate).getTime()
              );
            case "Ascending":
              return a.Name.localeCompare(b.Name);
            case "Descending":
              return b.Name.localeCompare(a.Name);
            case "Last Month":
              const oneMonthAgo = new Date();
              oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
              const lastMonthCreatedDate =
                new Date(b.JoiningDate).getTime() -
                new Date(a.JoiningDate).getTime();

              if (
                new Date(b.JoiningDate) >= oneMonthAgo &&
                new Date(a.JoiningDate) >= oneMonthAgo
              ) {
                return lastMonthCreatedDate;
              } else {
                return 0;
              }
            case "Last 7 Days":
              const sevenDaysAgo = new Date();
              sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
              const last7DaysCreatedDate =
                new Date(b.JoiningDate).getTime() -
                new Date(a.JoiningDate).getTime();

              if (
                new Date(b.JoiningDate) >= sevenDaysAgo &&
                new Date(a.JoiningDate) >= sevenDaysAgo
              ) {
                return last7DaysCreatedDate;
              } else {
                return 0;
              }

            default:
              return (
                new Date(b.JoiningDate).getTime() -
                new Date(a.JoiningDate).getTime()
              );
          }
        });
      var dateFilter = [...newFilteredData];
      if (dateFilter.length > 0) {
        setFilteredData(dateFilter);
      } else {
        if (data.length > 0) {
          setFilteredData([]);
        }
      }
    }
  }, [statusFilter, sortBy, selectedStartDate, selectedEndDate, companyName]);

  const handleDateChange = (start: moment.Moment, end: moment.Moment) => {
    setSelectedStartDate(start);
    setSelectedEndDate(end);
  };

  const companyChooseFilter = [
    ...getAllCompanyList.map((company) => ({
      value: company.id,
      label: company.name,
    })),
  ];

  return (
    <>
      {/* Page Wrapper */}
      {isLoading && <Loader />}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Employee</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Employee</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Employee Grid
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="me-2 mb-2">
                <div className="d-flex align-items-center border bg-white rounded p-1 me-2 icon-list">
                  <Link
                    to={all_routes.employeeList}
                    className="btn btn-icon btn-sm me-1"
                    title="List"
                  >
                    <i className="ti ti-list-tree" />
                  </Link>
                  <Link
                    to={all_routes.employeeGrid}
                    className="btn btn-icon btn-sm active bg-primary text-white"
                    title="Grid"
                  >
                    <i className="ti ti-layout-grid" />
                  </Link>
                </div>
              </div>

              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}
          <div className="row">
            {/* Total Plans */}
            <div className="col-xl col-lg-4 col-md-6 d-flex">
              <div className="card flex-fill">
                <div className="card-body d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center overflow-hidden">
                    <div>
                      <span className="avatar avatar-lg bg-dark rounded-circle">
                        <i className="ti ti-users" />
                      </span>
                    </div>
                    <div className="ms-2 overflow-hidden">
                      <p className="fs-12 fw-medium mb-1 text-truncate">
                        Total Employee
                      </p>
                      <h4>
                        {data?.filter(
                          (item) => item.CompanyName === companyName.name
                        ).length || 0}
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* /Total Plans */}
            {/* Total Plans */}
            <div className="col-xl col-lg-4 col-md-6 d-flex">
              <div className="card flex-fill">
                <div className="card-body d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center overflow-hidden">
                    <div>
                      <span className="avatar avatar-lg bg-success rounded-circle">
                        <i className="ti ti-user-share" />
                      </span>
                    </div>
                    <div className="ms-2 overflow-hidden">
                      <p className="fs-12 fw-medium mb-1 text-truncate">
                        Active
                      </p>
                      <h4>
                        {data?.filter(
                          (item) =>
                            item.Status == "Active" &&
                            item.CompanyName === companyName.name
                        ).length || 0}
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* /Total Plans */}
            {/* Inactive Plans */}
            <div className="col-xl col-lg-4 col-md-6 d-flex">
              <div className="card flex-fill">
                <div className="card-body d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center overflow-hidden">
                    <div>
                      <span className="avatar avatar-lg bg-danger rounded-circle">
                        <i className="ti ti-user-pause" />
                      </span>
                    </div>
                    <div className="ms-2 overflow-hidden">
                      <p className="fs-12 fw-medium mb-1 text-truncate">
                        InActive
                      </p>
                      <h4>
                        {data?.filter(
                          (item) =>
                            item.Status === "Inactive" &&
                            item.CompanyName === companyName.name
                        ).length || 0}
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* /Inactive Companies */}
            {/* Suspended Plans */}
            <div className="col-xl col-lg-4 col-md-6 d-flex">
              <div className="card flex-fill">
                <div className="card-body d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center overflow-hidden">
                    <div>
                      <span className="avatar avatar-lg bg-warning rounded-circle">
                        <i className="ti ti-user-exclamation" />
                      </span>
                    </div>
                    <div className="ms-2 overflow-hidden">
                      <p className="fs-12 fw-medium mb-1 text-truncate">
                        Suspended
                      </p>
                      <h4>
                        {data?.filter(
                          (item) =>
                            item.Status === "Suspended" &&
                            item.CompanyName === companyName.name
                        ).length || 0}
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* /Suspended Companies */}
            {/* No of Plans  */}
            <div className="col-xl col-lg-4 col-md-6 d-flex">
              <div className="card flex-fill">
                <div className="card-body d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center overflow-hidden">
                    <div>
                      <span className="avatar avatar-lg bg-info rounded-circle">
                        <i className="ti ti-user-plus" />
                      </span>
                    </div>
                    <div className="ms-2 overflow-hidden">
                      <p className="fs-12 fw-medium mb-1 text-truncate">
                        New Joiners
                      </p>
                      <h4>
                        {data?.filter((item) => {
                          const today = moment();
                          const joiningDate = moment(
                            item.JoiningDate,
                            "DD-MM-YYYY"
                          );
                          const isWithin30Days =
                            today.diff(joiningDate, "days") <= 30;

                          return (
                            item.CompanyName === companyName.name &&
                            isWithin30Days
                          );
                        }).length || 0}
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* /No of Plans */}
          </div>

          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <h5>Employees Grid</h5>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="me-3">
                  <div className="input-icon-end position-relative">
                    <PredefinedDateRanges onDateChange={handleDateChange} />
                    <span className="input-icon-addon">
                      <i className="ti ti-chevron-down" />
                    </span>
                  </div>
                </div>
                <div className="dropdown me-3">
                  <CommonSelect
                    className="select"
                    options={companyChooseFilter}
                    defaultValue={{
                      value: companyName?.id,
                      label: companyName?.name,
                    }}
                    onChange={async (selectedOption: any) => {
                      setCompanyName({
                        id: selectedOption.value,
                        name: selectedOption.label,
                      });
                    }}
                  />
                </div>
                <div className="dropdown me-3">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    Status {statusFilter}
                  </Link>
                  <ul className="dropdown-menu dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                        onClick={() => setStatusFilter("Active")}
                      >
                        Active
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                        onClick={() => setStatusFilter("Inactive")}
                      >
                        Inactive
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                        onClick={() => setStatusFilter("Suspended")}
                      >
                        Suspended
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="dropdown me-3">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    Sort By: {sortBy}
                  </Link>
                  <ul className="dropdown-menu dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                        onClick={() => setSortBy("Recently Added")}
                      >
                        Recently Added
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                        onClick={() => setSortBy("Ascending")}
                      >
                        Ascending
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                        onClick={() => setSortBy("Descending")}
                      >
                        Descending
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                        onClick={() => setSortBy("Last Month")}
                      >
                        Last Month
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                        onClick={() => setSortBy("Last 7 Days")}
                      >
                        Last 7 Days
                      </Link>
                    </li>
                  </ul>
                </div>
                <div>
                  <button
                    type="button"
                    className="btn btn-success"
                    onClick={handleReset}
                  >
                    Reset
                  </button>
                </div>
              </div>
            </div>
            <div className="row" style={{ marginTop: "10px" }}>
              {filteredData.map((employee) => (
                <div
                  key={JSON.stringify(employee)}
                  className="col-xl-3 col-lg-4 col-md-6"
                >
                  <div className="card">
                    <div className="card-body">
                      <div className="d-flex justify-content-between align-items-start mb-2">
                        <div className="form-check form-check-md">
                          {/* <input className="form-check-input" type="checkbox" /> */}
                        </div>
                        <div
                          style={{
                            width: "80px",
                            height: "80px",
                            borderRadius: "50%",
                            overflow: "hidden",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Link
                            to={all_routes.employeedetails.replace(
                              ":id",
                              employee.key
                            )}
                            state={{ type: "emp_grid" }}
                            className={`avatar avatar-xl avatar-rounded border p-1 rounded-circle ${
                              employee.Status == "Active"
                                ? "border-success"
                                : employee.Status == "Suspended"
                                ? "border-warning"
                                : "border-danger"
                            }`}
                            style={{ width: "100%", height: "100%" }}
                          >
                            <ImageWithBasePath
                              src={
                                employee.Image || "assets/img/users/user.png"
                              }
                              className="img-fluid"
                              alt="employee"
                            />
                          </Link>
                        </div>

                        <div className="dropdown">
                          <button
                            className="btn btn-icon btn-sm rounded-circle"
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            <i className="ti ti-dots-vertical" />
                          </button>
                          <ul className="dropdown-menu dropdown-menu-end p-3">
                            <li>
                              <Link
                                className="dropdown-item rounded-1"
                                to="#"
                                data-bs-toggle="modal"
                                data-inert={true}
                                data-bs-target="#edit_employee"
                                onClick={(e: any) =>
                                  handleEditOpenModal(employee)
                                }
                              >
                                <i className="ti ti-edit me-1" /> Edit
                              </Link>
                            </li>
                            <li>
                              <Link
                                className="dropdown-item rounded-1"
                                to="#"
                                data-bs-toggle="modal"
                                data-inert={true}
                                data-bs-target="#delete_modal"
                                onClick={() => setDeleteRecord(employee)}
                              >
                                <i className="ti ti-trash me-1" /> Delete
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="text-center mb-3">
                        <h6 className="mb-1">
                          <Link
                            to={all_routes.employeedetails.replace(
                              ":id",
                              employee.key
                            )}
                            state={{
                              type: "emp_grid",
                            }}
                          >
                            {employee.Name}
                          </Link>
                        </h6>

                        <span className="badge bg-pink-transparent fs-10 fw-medium">
                          {employee.Designation} - {employee.Department}
                        </span>
                      </div>
                      <div className="row text-center">
                        <h6 className="mb-3">
                          <span
                            className={`badge ms-2 fs-10 fw-medium ${
                              employee.Status == "Active"
                                ? "bg-success"
                                : employee.Status == "Suspended"
                                ? "bg-warning"
                                : "bg-danger"
                            }`}
                          >
                            {employee.Status == "Active"
                              ? "Active"
                              : employee.Status == "Suspended"
                              ? "Suspended"
                              : "Inactive"}
                          </span>
                        </h6>
                      </div>
                      <div className="row text-center">
                        <div className="col-4">
                          <div className="mb-3">
                            <span className="fs-12">Projects</span>
                            <h6 className="fw-medium">0</h6>
                          </div>
                        </div>
                        <div className="col-4">
                          <div className="mb-3">
                            <span className="fs-12">Done</span>
                            <h6 className="fw-medium">0</h6>
                          </div>
                        </div>
                        <div className="col-4">
                          <div className="mb-3">
                            <span className="fs-12">Progress</span>
                            <h6 className="fw-medium">0</h6>
                          </div>
                        </div>
                      </div>
                      <p className="mb-2 text-center">
                        Productivity : <span className="text-purple"> 0%</span>
                      </p>
                      <div className="progress progress-xs mb-2">
                        <div
                          className="progress-bar bg-purple"
                          role="progressbar"
                          style={{ width: `0%` }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          {/* Clients Grid */}

          {/* /Clients Grid */}
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">2025 © CMS.</p>
          <p>
            Designed & Developed By{" "}
            <Link to="#" className="text-primary">
              ZYVO
            </Link>
          </p>
        </div>
      </div>
      {/* /Page Wrapper */}

      <EditEmployee
        data={modalData}
        onClose={() => {
          fetchUpdatedRecords();
          //fetchData(); // Example function to call on close
        }}
      />

      <DeleteModal
        modalId="delete_modal"
        onDelete={handleDelete}
        title="Delete Item"
        message="Are you sure you want to delete this item? This action cannot be undone."
      />
    </>
  );
};

export default EmployeesGrid;
